import React, { useState } from "react";
import * as XLSX from "xlsx";

// Component
import SearchForm from "../../../../component/search-form";
import { sanitizeInput } from "../../../../utils";
import useDebounce from "../../../../Hook/useDebounce";
import CreateAndUpdateCorrectionOrder from "./CreateAndUpdateCorrectionOrder";
import CorrectionOrderTable from "./CorrectionOrderTable";
import UploadExcelFile from "./UploadExcelFile";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../../component/modal-popup/customeModal";

// Redux
import { useSelector, useDispatch } from "react-redux";
import { addBulkCorrectionOrder } from "../../../../redux/actions/correctionOrder";

function CorrectionOrderIndex({ updateCounter, setUpdateCounter }) {
  // State
  const [searchText, setSearchText] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [update, setUpdate] = useState(1);
  const [openUploadModalPopup, setOpenUploadModalPopup] = useState(false);

  // Redux
  const { correctionOrderData } = useSelector((state) => state.correctionOrder);
  const dispatch = useDispatch();

  const debouncedHandleSearch = useDebounce(searchText, 300);

  // Function to call bulk correction order API calling
  const createBulkCorrectionOrder = (payload) => {
    const request = {
      payload,
      onSuccess: () => {
        setUpdate(update + 1);
        setUpdateCounter(updateCounter + 1);
        setOpenUploadModalPopup(false)
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(addBulkCorrectionOrder(request));
  };

  // Function to create Payload
  const createPayload = (productJSON, skuJSON) => {
    // creating payload for product
    const products = productJSON
      .filter(
        (filterEle) =>
          filterEle?.["Act. Quantity"] &&
          /^\d*$/.test(filterEle?.["Act. Quantity"])
      )
      .map((mappedEle) => {
        const obj = {
          id: mappedEle.product_master_id,
          qty: Number(mappedEle["Act. Quantity"]),
          remarks: mappedEle?.Remarks ? mappedEle?.Remarks : "",
        };
        return obj;
      });

    // creating payload for sku
    const skus = skuJSON
      .filter(
        (filteredEle) =>
          filteredEle?.["Act. Quantity"] &&
          /^-?(?:[1-9]\d*|\d+\.\d*[1-9])$/.test(filteredEle?.["Act. Quantity"])
      )
      .map((mappedEle) => {
        const obj = {
          id: mappedEle.sku_master_id,
          qty: Number(mappedEle["Act. Quantity"]),
          remarks: mappedEle?.Remarks ? mappedEle?.Remarks : "",
        };
        return obj;
      });

    createBulkCorrectionOrder({ products, skus });
  };

  // Function to extract data from excel
  const handleExcelFileUpload = (uploaded_file_data) => {
    const file = uploaded_file_data;
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Reading the first sheet
      const sheetName1 = workbook.SheetNames[0];
      const worksheet1 = workbook.Sheets[sheetName1];

      // Reading the second sheet
      const sheetName2 = workbook.SheetNames[1];
      const worksheet2 = workbook.Sheets[sheetName2];

      // Convert the sheet to JSON
      const jsonData1 = XLSX.utils.sheet_to_json(worksheet1);
      const jsonData2 = XLSX.utils.sheet_to_json(worksheet2);

      createPayload(jsonData1, jsonData2);
    };
    reader.readAsArrayBuffer(file);
  };

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 px-6 py-4 bg-[--bg-color-50] rounded">
        <div className="space-x-4 flex items-center">
          <h4 className="text-xl leading-5 font-bold tracking-tight">
            Correction Orders
          </h4>
          <SearchForm
            placeholder="Search"
            onChange={(e) => {
              const value = sanitizeInput(e.target.value);
              setSearchText(value);
            }}
            value={searchText}
          />
          <h4 className="text-[#535860] font-semibold text-sm leading-[100%]">
            Correction Orders:{" "}
            {correctionOrderData ? correctionOrderData.totalCount : 0}
          </h4>
        </div>

        <div className="space-x-4 flex items-center justify-end">
          <button
            onClick={() => setOpenUploadModalPopup(true)}
            className="btn ml-0 md:ml-3 btn bg-white border-slate-200 hover:border-slate-300 text-slate-600"
          >
            Upload .xlsx File
          </button>
          <button
            className="btn ml-0 md:ml-3 !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
            onClick={() => setModalOpen(true)}
          >
            <span className={`fas fa-plus mr-2`}></span>
            New Correction Order
          </button>
        </div>
      </div>
      <CorrectionOrderTable
        debouncedHandleSearch={debouncedHandleSearch}
        update={update}
        setUpdate={setUpdate}
        updateCounter={updateCounter}
        setUpdateCounter={setUpdateCounter}
      />
      <CreateAndUpdateCorrectionOrder
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        update={update}
        setUpdate={setUpdate}
        updateCounter={updateCounter}
        setUpdateCounter={setUpdateCounter}
      />
      <UploadExcelFile
        openUploadModalPopup={openUploadModalPopup}
        setOpenUploadModalPopup={setOpenUploadModalPopup}
        handleExcelFileUpload={handleExcelFileUpload}
      />
    </div>
  );
}

export default CorrectionOrderIndex;
